import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const StrategiaPage = () => {
  const [visibleSections, setVisibleSections] = useState(0);
  const [copiedEmail, setCopiedEmail] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setVisibleSections(prev => {
        if (prev >= 30) { clearInterval(timer); return prev; }
        return prev + 1;
      });
    }, 180);
    return () => clearInterval(timer);
  }, []);

  const fadeIn = (index) => ({
    opacity: visibleSections >= index ? 1 : 0,
    transform: visibleSections >= index ? 'translateY(0)' : 'translateY(20px)',
    transition: 'all 0.8s cubic-bezier(0.16, 1, 0.3, 1)',
  });

  const utile2025 = 29400000;
  const richiestaAnno = 30000;
  const percentualeAnno = ((richiestaAnno / utile2025) * 100).toFixed(2);

  const copyEmail = () => {
    const emailText = document.getElementById('email-corpo')?.innerText;
    if (emailText) {
      navigator.clipboard.writeText(emailText);
      setCopiedEmail(true);
      setTimeout(() => setCopiedEmail(false), 3000);
    }
  };

  return (
    <main data-testid="strategia-page" className="min-h-screen pt-20 pb-16 bg-black text-white">
      <div className="max-w-3xl mx-auto px-6">

        {/* Header */}
        <div style={fadeIn(0)} className="text-center mb-16">
          <p className="font-mono text-[10px] uppercase tracking-[0.4em] text-zinc-600 mb-4">
            DOCUMENTO STRATEGICO RISERVATO
          </p>
          <div className="w-16 h-[1px] bg-[#00FF41]/30 mx-auto mb-6" />
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black mb-3">
            Strategia Finanziaria & Legale
          </h1>
          <p className="text-[#00FF41] font-mono text-sm mb-2">
            &lt;/AI_covo.tech&gt;<sup className="text-[8px]">&reg;</sup>
          </p>
          <p className="text-zinc-500 text-xs">
            Piano completo: Forma giuridica, fondi, budget, proposta ChiantiBanca
          </p>
        </div>

        {/* ═══════════════════════════════════════════════════════ */}
        {/* SEZIONE 1 — FORMA GIURIDICA */}
        {/* ═══════════════════════════════════════════════════════ */}
        <div style={fadeIn(1)} className="mb-14">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-6">
            1. FORMA GIURIDICA CONSIGLIATA
          </p>
          <div className="bg-[#0A0A0A] border border-[#00FF41]/20 p-6 sm:p-8 mb-6">
            <p className="text-xl sm:text-2xl font-black text-[#00FF41] mb-3">
              Società Cooperativa a r.l.
            </p>
            <p className="text-white font-bold text-sm mb-1">
              qualificata come Impresa Sociale (D.Lgs. 112/2017)
            </p>
            <p className="text-zinc-500 text-xs">
              Iscritta al RUNTS — Registro Unico Nazionale Terzo Settore
            </p>
          </div>

          {/* Tabella confronto */}
          <div className="overflow-x-auto mb-6">
            <table className="w-full text-xs font-mono">
              <thead>
                <tr className="border-b border-zinc-700">
                  <th className="text-left py-2 text-zinc-400">Forma</th>
                  <th className="text-left py-2 text-zinc-400">Pro</th>
                  <th className="text-left py-2 text-zinc-400">Contro</th>
                  <th className="text-center py-2 text-zinc-400">Verdetto</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-zinc-900">
                  <td className="py-3 text-white">Associazione + P.IVA</td>
                  <td className="py-3 text-zinc-400">Semplice</td>
                  <td className="py-3 text-red-400">No bandi PNRR come impresa; no credibilita bancaria</td>
                  <td className="py-3 text-center text-red-400 font-bold">NO</td>
                </tr>
                <tr className="border-b border-zinc-900">
                  <td className="py-3 text-white">SRLS</td>
                  <td className="py-3 text-zinc-400">Costi bassi</td>
                  <td className="py-3 text-red-400">Esclusa da agevolazioni ETS; meno appeal per BCC</td>
                  <td className="py-3 text-center text-red-400 font-bold">NO</td>
                </tr>
                <tr className="border-b border-zinc-900 bg-[#00FF41]/5">
                  <td className="py-3 text-[#00FF41] font-bold">Coop Sociale</td>
                  <td className="py-3 text-[#00FF41]">PNRR, RUNTS, fiscalità, coerente con BCC</td>
                  <td className="py-3 text-zinc-400">Serve min. 3 soci</td>
                  <td className="py-3 text-center text-[#00FF41] font-bold">SI</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Vantaggi fiscali 2026 */}
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#FFD700] mb-4">
            VANTAGGI FISCALI DAL 1 GENNAIO 2026 (DL 84/2025)
          </p>
          <div className="space-y-2 mb-6">
            {[
              { icon: '+', text: '100% utili NON IMPONIBILI se accantonati a riserva indivisibile o reinvestiti', color: 'text-[#00FF41]' },
              { icon: '+', text: 'Investitori: detrazione IRPEF 30% (PF, max 1M/anno) o deduzione IRES 30% (societa)', color: 'text-[#00FF41]' },
              { icon: '+', text: 'Esenzione ISA (Indici Sintetici di Affidabilità)', color: 'text-[#00FF41]' },
              { icon: '+', text: 'Ammissibilità piena a bandi PNRR, FSE+, Toscana Diffusa, Fondazioni', color: 'text-[#00FF41]' },
              { icon: '+', text: 'Lo statuto cooperativo parla la stessa lingua di ChiantiBanca (mutualità, territorio)', color: 'text-[#FFD700]' },
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-3 p-3 border border-zinc-800">
                <span className={`${item.color} font-mono text-xs font-bold flex-shrink-0`}>{item.icon}</span>
                <p className="text-zinc-300 text-xs">{item.text}</p>
              </div>
            ))}
          </div>

          <div className="p-4 border border-[#FFD700]/20 bg-[#FFD700]/5">
            <p className="text-[#FFD700] text-xs font-bold mb-1">Azione immediata</p>
            <p className="text-zinc-400 text-xs">
              Costituire la Cooperativa con atto notarile, iscriverla al RUNTS e al Registro Imprese come Impresa Sociale.
              Costo stimato: ~800-1.200 EUR. Tempo: 15-20 giorni.
            </p>
          </div>
        </div>

        {/* ═══════════════════════════════════════════════════════ */}
        {/* SEZIONE 2 — PIANO FONDI: 3 PILASTRI */}
        {/* ═══════════════════════════════════════════════════════ */}
        <div style={fadeIn(3)} className="mb-14">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-6">
            2. PIANO FONDI — TRE PILASTRI
          </p>
          <div className="text-center mb-8 p-6 bg-[#0A0A0A] border border-[#00FF41]/20">
            <p className="text-zinc-500 text-[10px] font-mono uppercase mb-2">OBIETTIVO ANNUALE</p>
            <p className="text-4xl sm:text-5xl font-black text-[#00FF41]">88.750</p>
            <p className="text-zinc-500 text-xs mt-1">rendicontati</p>
          </div>

          <div className="space-y-4 mb-8">
            {/* Pilastro ChiantiBanca */}
            <div className="border border-[#FFD700]/20 p-5">
              <div className="flex items-center justify-between mb-3">
                <p className="text-[#FFD700] font-bold text-sm">A. ChiantiBanca</p>
                <p className="text-[#FFD700] font-mono font-bold">30.000/anno x 10</p>
              </div>
              <p className="text-zinc-400 text-xs mb-3">
                Sponsorizzazione + visibilita. Integralmente deducibile come spesa pubblicitaria (art. 108 TUIR).
              </p>
              <div className="flex items-center gap-2">
                <span className="text-[10px] font-mono text-zinc-600">STATUS:</span>
                <span className="text-[10px] font-mono text-[#FFD700] bg-[#FFD700]/10 px-2 py-0.5">DA NEGOZIARE</span>
              </div>
            </div>

            {/* Pilastro Regione Toscana */}
            <div className="border border-blue-500/20 p-5">
              <div className="flex items-center justify-between mb-3">
                <p className="text-blue-400 font-bold text-sm">B. Regione Toscana</p>
                <p className="text-blue-400 font-mono font-bold">30.000-40.000/anno</p>
              </div>
              <p className="text-zinc-400 text-xs mb-2">Bandi disponibili:</p>
              <ul className="text-zinc-400 text-xs space-y-1 pl-4">
                <li className="flex items-start gap-2">
                  <span className="text-blue-400">&#8250;</span>
                  <span><span className="text-white font-bold">Toscana Diffusa</span> — 13,7M per 28 progetti (max 600k/progetto). Rifinanziamento 10M annunciato da Giani</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-400">&#8250;</span>
                  <span><span className="text-white font-bold">FSE+ 2021-2027</span> — 1,1 MLD per occupazione, inclusione, crescita. Bandi riuso spazi sfitti</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-400">&#8250;</span>
                  <span><span className="text-white font-bold">Fondo Sviluppo e Coesione</span> — 683M assegnati alla Toscana</span>
                </li>
              </ul>
              <div className="flex items-center gap-2 mt-3">
                <span className="text-[10px] font-mono text-zinc-600">STATUS:</span>
                <span className="text-[10px] font-mono text-blue-400 bg-blue-400/10 px-2 py-0.5">MONITORARE BANDI</span>
              </div>
            </div>

            {/* Pilastro PNRR */}
            <div className="border border-purple-500/20 p-5">
              <div className="flex items-center justify-between mb-3">
                <p className="text-purple-400 font-bold text-sm">C. PNRR / Europa</p>
                <p className="text-purple-400 font-mono font-bold">18.750-28.750/anno</p>
              </div>
              <p className="text-zinc-400 text-xs mb-2">
                Missione 5 — Inclusione e Coesione. 162M per 30 progetti PINQUA in Toscana.
              </p>
              <ul className="text-zinc-400 text-xs space-y-1 pl-4">
                <li className="flex items-start gap-2">
                  <span className="text-purple-400">&#8250;</span>
                  <span>Rifunzionalizzazione spazi pubblici inutilizzati</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-purple-400">&#8250;</span>
                  <span>Decoro urbano e servizi sociali</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-purple-400">&#8250;</span>
                  <span>Cooperative sociali iscritte RUNTS tra soggetti ammissibili</span>
                </li>
              </ul>
              <div className="flex items-center gap-2 mt-3">
                <span className="text-[10px] font-mono text-zinc-600">STATUS:</span>
                <span className="text-[10px] font-mono text-purple-400 bg-purple-400/10 px-2 py-0.5">BANDI IN SCORRIMENTO</span>
              </div>
            </div>
          </div>

          {/* L'argomento killer */}
          <div className="bg-[#0A0A0A] border border-[#FFD700]/30 p-6 sm:p-8">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#FFD700] mb-4">
              L'ARGOMENTO KILLER — CHIANTIBANCA
            </p>
            <div className="grid grid-cols-2 gap-3 mb-4">
              <div className="border border-zinc-800 p-3 text-center">
                <p className="text-lg font-black text-white">29,4M</p>
                <p className="text-zinc-500 text-[10px] font-mono">UTILE 2025</p>
              </div>
              <div className="border border-zinc-800 p-3 text-center">
                <p className="text-lg font-black text-white">99,2M</p>
                <p className="text-zinc-500 text-[10px] font-mono">TRIENNIO CUMULATO</p>
              </div>
              <div className="border border-zinc-800 p-3 text-center">
                <p className="text-lg font-black text-white">1,5M</p>
                <p className="text-zinc-500 text-[10px] font-mono">SPONSORIZZAZIONI 2025</p>
              </div>
              <div className="border border-zinc-800 p-3 text-center">
                <p className="text-lg font-black text-white">1,8M</p>
                <p className="text-zinc-500 text-[10px] font-mono">VIA CHIANTIMUTUA</p>
              </div>
            </div>
            <div className="p-3 bg-[#FFD700]/5 border border-[#FFD700]/10 text-center">
              <p className="text-[#FFD700] text-sm font-bold">
                30.000/anno = {percentualeAnno}% dell'utile netto 2025
              </p>
              <p className="text-zinc-500 text-[10px] mt-1">
                Cifra irrisoria per loro. Trasformativa per il progetto.
              </p>
            </div>
          </div>
        </div>

        {/* ═══════════════════════════════════════════════════════ */}
        {/* SEZIONE 3 — BUDGET ANNUALE */}
        {/* ═══════════════════════════════════════════════════════ */}
        <div style={fadeIn(5)} className="mb-14">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-6">
            3. BUDGET ANNUALE DETTAGLIATO
          </p>

          <div className="overflow-x-auto mb-6">
            <table className="w-full text-xs font-mono">
              <thead>
                <tr className="border-b border-zinc-700">
                  <th className="text-left py-2 text-zinc-400">Voce</th>
                  <th className="text-right py-2 text-zinc-400">Importo</th>
                  <th className="text-right py-2 text-zinc-400">%</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { voce: 'Maieuta + Corsi + Coaching', importo: 22250, perc: '25,1%', color: 'text-white' },
                  { voce: 'AI Expert / Google Trusted / Sales Manager + Corsi', importo: 22250, perc: '25,1%', color: 'text-white' },
                  { voce: 'Psicologo (team + sportello Mentor)', importo: 10750, perc: '12,1%', color: 'text-white' },
                  { voce: 'Sede: affitto agevolato, utenze, manutenzione', importo: 15000, perc: '16,9%', color: 'text-white' },
                  { voce: 'Fondo cassa emergenza', importo: 3000, perc: '3,4%', color: 'text-zinc-400' },
                  { voce: 'Riqualificazione capannone (una tantum, Anno 1)', importo: 15500, perc: '17,5%', color: 'text-[#FFD700]' },
                ].map((row, i) => (
                  <tr key={i} className="border-b border-zinc-900">
                    <td className={`py-3 ${row.color}`}>{row.voce}</td>
                    <td className="py-3 text-right text-[#00FF41] font-bold">{row.importo.toLocaleString('it-IT')}</td>
                    <td className="py-3 text-right text-zinc-500">{row.perc}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="border-t-2 border-[#00FF41]/30">
                  <td className="py-3 text-[#00FF41] font-bold">TOTALE</td>
                  <td className="py-3 text-right text-[#00FF41] font-bold">88.750</td>
                  <td className="py-3 text-right text-[#00FF41] font-bold">100%</td>
                </tr>
              </tfoot>
            </table>
          </div>

          {/* Visualizzazione a barre */}
          <div className="bg-[#0A0A0A] border border-zinc-800 p-5">
            <p className="text-zinc-500 text-[10px] font-mono uppercase mb-4">DISTRIBUZIONE BUDGET</p>
            {[
              { label: 'Maieuta', perc: 25.1, color: '#00FF41' },
              { label: 'AI Expert', perc: 25.1, color: '#33FF66' },
              { label: 'Psicologo', perc: 12.1, color: '#66FF88' },
              { label: 'Sede', perc: 16.9, color: '#FFD700' },
              { label: 'Riqualif.', perc: 17.5, color: '#FFA500' },
              { label: 'Emergenza', perc: 3.4, color: '#FF6B6B' },
            ].map((item, i) => (
              <div key={i} className="mb-2">
                <div className="flex justify-between text-[10px] font-mono mb-1">
                  <span className="text-zinc-400">{item.label}</span>
                  <span style={{ color: item.color }}>{item.perc}%</span>
                </div>
                <div className="w-full h-2 bg-zinc-900 overflow-hidden">
                  <div className="h-full" style={{ width: `${item.perc}%`, backgroundColor: item.color, opacity: 0.6 }} />
                </div>
              </div>
            ))}
          </div>

          {/* Nota strategica */}
          <div className="mt-6 p-4 border border-zinc-800 bg-[#0A0A0A]">
            <p className="text-zinc-500 text-[10px] font-mono uppercase mb-2">NOTA STRATEGICA</p>
            <p className="text-zinc-400 text-xs leading-relaxed">
              Le 3 figure non sono "stipendi" ma <span className="text-white font-bold">compensi per prestazioni professionali</span> alla cooperativa 
              (contratti di collaborazione o co.co.co.), perfettamente legittimi per un'impresa sociale. 
              La cooperativa non distribuisce utili, ma può remunerare i professionisti che erogano servizi di interesse generale.
            </p>
          </div>
        </div>

        {/* ═══════════════════════════════════════════════════════ */}
        {/* SEZIONE 4 — EMAIL PERSUASIVA CHIANTIBANCA */}
        {/* ═══════════════════════════════════════════════════════ */}
        <div style={fadeIn(7)} className="mb-14">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#FFD700] mb-6">
            4. EMAIL PERSUASIVA — CHIANTIBANCA
          </p>

          <div className="bg-[#0A0A0A] border border-[#FFD700]/20 p-6 sm:p-8" id="email-corpo">
            {/* Oggetto */}
            <div className="mb-6 pb-4 border-b border-zinc-800">
              <p className="text-zinc-500 text-[10px] font-mono">OGGETTO:</p>
              <p className="text-white font-bold text-sm mt-1">
                Proposta di Partnership Territoriale — Hub Digitale &lt;/AI_covo.tech&gt;® per la Rigenerazione Sociale del Chianti
              </p>
            </div>

            {/* Destinatari */}
            <div className="mb-6 pb-4 border-b border-zinc-800">
              <p className="text-zinc-500 text-[10px] font-mono mb-2">A:</p>
              <p className="text-white text-xs">Spett.le Presidenza e Direzione Generale ChiantiBanca</p>
              <p className="text-zinc-400 text-xs">Alla cortese attenzione del Presidente Cristiano Iacopozzi</p>
              <p className="text-zinc-400 text-xs">e del Direttore Generale Maurizio Farnesi</p>
            </div>

            {/* Corpo email */}
            <div className="space-y-4 text-xs text-zinc-300 leading-relaxed">
              <p>
                Egregi Presidente Iacopozzi e Direttore Farnesi,
              </p>
              <p>
                mi rivolgo a Voi con profondo rispetto per cio che ChiantiBanca rappresenta: non una banca, 
                ma un <span className="text-white font-bold">presidio di comunità</span> — il primo in Toscana per compagine sociale, 
                con 34.400 soci che Vi affidano non solo il risparmio, ma la speranza che il territorio cresca.
              </p>
              <p>
                Vi scrivo perché condividiamo la stessa missione. E perché crediamo che 
                <span className="text-[#00FF41] font-bold"> il modo migliore per difendere un territorio sia investire nelle sue generazioni future</span>.
              </p>

              {/* Chi siamo */}
              <div className="my-6 py-4 border-t border-b border-zinc-800">
                <p className="text-white font-bold text-sm mb-3">CHI SIAMO</p>
                <p>
                  &lt;/AI_covo.tech&gt;® e un progetto di <span className="text-white font-bold">rigenerazione sociale attraverso la tecnologia 
                  e la formazione</span>. Siamo una Cooperativa Sociale — Impresa Sociale iscritta al RUNTS — che sta trasformando 
                  un capannone inutilizzato nel Chianti in un Hub digitale dove giovani, famiglie e professionisti accedono gratuitamente a:
                </p>
                <ul className="mt-3 space-y-1.5 pl-4">
                  <li className="flex items-start gap-2">
                    <span className="text-[#00FF41]">&#8250;</span>
                    <span><span className="text-white font-bold">Formazione AI e competenze digitali</span> (corsi, coaching, certificazioni Google)</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#00FF41]">&#8250;</span>
                    <span><span className="text-white font-bold">Sportello psicologico "Mentor"</span> per il benessere della comunità</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#00FF41]">&#8250;</span>
                    <span><span className="text-white font-bold">Archivio Digitale gamificato</span> per scuole e associazioni locali</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#00FF41]">&#8250;</span>
                    <span><span className="text-white font-bold">Piattaforma web proprietaria</span> già funzionante (podcast, video formativi, AI chat)</span>
                  </li>
                </ul>
                <p className="mt-3">
                  Non siamo un'idea. <span className="text-[#00FF41] font-bold">Siamo già operativi digitalmente</span>. Ora serve la sede fisica.
                </p>
              </div>

              {/* La richiesta */}
              <div className="my-6 py-4 border-t border-b border-zinc-800">
                <p className="text-white font-bold text-sm mb-3">COSA CHIEDIAMO</p>
                <p>
                  Una <span className="text-[#FFD700] font-bold">sponsorizzazione di 30.000 EUR annui per 10 anni</span>, pari a un investimento 
                  complessivo di 300.000 EUR.
                </p>
                <div className="mt-4 grid grid-cols-2 gap-2">
                  <div className="border border-zinc-800 p-3 text-center">
                    <p className="text-lg font-black text-white">29.400.000</p>
                    <p className="text-zinc-500 text-[10px] font-mono">UTILE NETTO 2025</p>
                  </div>
                  <div className="border border-[#FFD700]/20 p-3 text-center">
                    <p className="text-lg font-black text-[#FFD700]">30.000</p>
                    <p className="text-zinc-500 text-[10px] font-mono">NS. RICHIESTA ANNUA</p>
                  </div>
                </div>
                <p className="mt-4 text-center">
                  <span className="text-[#FFD700] font-bold">{percentualeAnno}%</span> dell'utile. 
                  Il <span className="text-white font-bold">2%</span> di quanto gia erogate in sponsorizzazioni ogni anno.
                </p>
              </div>

              {/* Cosa offriamo */}
              <div className="my-6 py-4 border-t border-b border-zinc-800">
                <p className="text-white font-bold text-sm mb-3">COSA OFFRIAMO IN CAMBIO</p>
                <div className="space-y-2">
                  {[
                    'Visibilita digitale permanente: Logo ChiantiBanca su piattaforma web, social media, newsletter, materiali formativi',
                    'Co-branding eventi: Ogni corso, workshop e inaugurazione portera il nome ChiantiBanca come Partner Fondatore',
                    'Report d\'impatto annuale: Dati verificabili su persone formate, ore di coaching, accessi sportello psicologico',
                    'Allineamento statutario: Il Vostro sostegno a un\'Impresa Sociale rafforza la narrazione cooperativa e mutualistica',
                    'Deducibilità fiscale integrale: La sponsorizzazione è interamente deducibile come spesa pubblicitaria (art. 108 TUIR)',
                  ].map((item, i) => (
                    <div key={i} className="flex items-start gap-2">
                      <span className="text-[#00FF41] font-bold flex-shrink-0">{i + 1}.</span>
                      <p>{item}</p>
                    </div>
                  ))}
                </div>

                {/* Convenzione Bancaria */}
                <div className="mt-4 p-3 bg-[#FFD700]/5 border border-[#FFD700]/10">
                  <p className="text-[#FFD700] font-bold text-xs mb-2">INTEGRAZIONE BANCARIA</p>
                  <p><span className="text-[#FFD700] font-bold">6.</span> Conto Online per ogni Socio: Ogni iscritto avra diritto a una convenzione dedicata per aprire un conto corrente online ChiantiBanca (modello Alphabet/Fideuram). 2.500 potenziali nuovi correntisti.</p>
                  <p className="mt-1"><span className="text-[#FFD700] font-bold">7.</span> C/C e IBAN del Covo presso ChiantiBanca: Conto corrente operativo della Cooperativa con IBAN dedicato. Tutte le transazioni (donazioni, iscrizioni, gateway) transiteranno su ChiantiBanca.</p>
                </div>
              </div>

              {/* Perché ora */}
              <div className="my-6 py-4 border-t border-b border-zinc-800">
                <p className="text-white font-bold text-sm mb-3">PERCHE ORA</p>
                <p>
                  I fondi PNRR Missione 5 e Toscana Diffusa stanno finanziando la rigenerazione di spazi inutilizzati 
                  in tutta la Toscana — ma <span className="text-white font-bold">servono partner privati credibili</span> per sbloccare 
                  i co-finanziamenti pubblici. Il Vostro impegno è la leva che attiva i fondi europei e regionali.
                </p>
                <div className="mt-4 p-3 bg-[#00FF41]/5 border border-[#00FF41]/10">
                  <p className="text-zinc-400 text-[10px] font-mono mb-2">PIANO FINANZIARIO TRIENNALE</p>
                  <p>ChiantiBanca: 30.000/anno (sponsorizzazione)</p>
                  <p>Regione Toscana / FSE+: 30.000-40.000/anno (bandi rigenerazione)</p>
                  <p>PNRR / Fondi europei: 18.750-28.750/anno (inclusione sociale)</p>
                  <p className="mt-2 text-white font-bold">Budget annuale totale: 88.750 EUR</p>
                </div>
              </div>

              {/* Passo successivo */}
              <div className="my-6 py-4 border-t border-zinc-800">
                <p className="text-white font-bold text-sm mb-3">IL PASSO SUCCESSIVO</p>
                <p>
                  Chiediamo 30 minuti del Vostro tempo. Verremo a presentarVi il progetto nella sede che preferite, 
                  con la piattaforma funzionante, il business plan triennale e la documentazione RUNTS.
                </p>
                <p className="mt-4 text-[#00FF41]">
                  Siamo certi che chi ha costruito la base cooperativa più grande della Toscana sapra riconoscere, 
                  in questo progetto, lo stesso spirito che anima ChiantiBanca da sempre: 
                  <span className="font-bold"> raccogliere dal territorio per restituire al territorio</span>.
                </p>
              </div>

              {/* Firma */}
              <div className="mt-6 pt-4 border-t border-zinc-800">
                <p>Con stima e gratitudine anticipata,</p>
                <p className="mt-3 text-white font-bold">[Nome Cognome]</p>
                <p className="text-zinc-400">Presidente — Cooperativa Sociale &lt;/AI_covo.tech&gt;®</p>
                <p className="text-zinc-500 mt-1">[Email] | [Telefono] | [Sito web]</p>
                <p className="text-zinc-600 text-[10px] mt-2 italic">
                  Allegati: Business Plan triennale, Statuto Cooperativa, Visura RUNTS, Mockup visibilità sponsor
                </p>
              </div>
            </div>
          </div>

          {/* Pulsante copia */}
          <button
            data-testid="copy-email-btn"
            onClick={copyEmail}
            className="mt-4 w-full font-mono text-xs text-center py-3 border transition-all duration-300"
            style={{
              borderColor: copiedEmail ? '#00FF41' : '#FFD700',
              color: copiedEmail ? '#00FF41' : '#FFD700',
              backgroundColor: copiedEmail ? 'rgba(0,255,65,0.05)' : 'transparent',
            }}
          >
            {copiedEmail ? 'COPIATO NEGLI APPUNTI' : 'COPIA TESTO EMAIL'}
          </button>
        </div>

        {/* ═══════════════════════════════════════════════════════ */}
        {/* SEZIONE 5 — PROSSIMI PASSI */}
        {/* ═══════════════════════════════════════════════════════ */}
        <div style={fadeIn(9)} className="mb-14">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-6">
            5. PROSSIMI PASSI OPERATIVI
          </p>
          <div className="space-y-0">
            {[
              { num: '01', azione: 'Costituire Cooperativa Sociale + iscrizione RUNTS', tempi: '15-20 giorni', costo: '~1.000', status: 'next' },
              { num: '02', azione: 'Inviare email a ChiantiBanca (segreteria presidenza)', tempi: 'Subito dopo #01', costo: '0', status: '' },
              { num: '03', azione: 'Follow-up telefonico ChiantiBanca', tempi: '7-10 gg dopo invio', costo: '0', status: '' },
              { num: '04', azione: 'Monitorare bando Toscana Diffusa 2026', tempi: 'Continuo', costo: '0', status: '' },
              { num: '05', azione: 'Candidatura FSE+ per riuso spazi (modello RESTART Prato)', tempi: 'Al primo bando utile', costo: '0', status: '' },
              { num: '06', azione: 'Presentare domanda PNRR Missione 5 al Comune', tempi: 'Quando aperto', costo: '0', status: '' },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-4 py-4 border-b border-zinc-900">
                <div className={`w-8 h-8 flex items-center justify-center flex-shrink-0 font-mono text-xs font-bold
                  ${item.status === 'next' ? 'bg-[#00FF41]/10 text-[#00FF41] border border-[#00FF41]/30' : 'bg-zinc-900 text-zinc-500 border border-zinc-800'}`}>
                  {item.num}
                </div>
                <div className="flex-1 min-w-0">
                  <p className={`text-sm ${item.status === 'next' ? 'text-[#00FF41] font-bold' : 'text-white'}`}>
                    {item.azione}
                  </p>
                  <div className="flex gap-4 mt-1">
                    <span className="text-zinc-500 text-[10px] font-mono">{item.tempi}</span>
                    <span className="text-zinc-600 text-[10px] font-mono">{item.costo} EUR</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ═══════════════════════════════════════════════════════ */}
        {/* SEZIONE 6 — FONTI & LINK CORRELATI */}
        {/* ═══════════════════════════════════════════════════════ */}
        <div style={fadeIn(11)} className="mb-14">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-6">
            6. FONTI E LINK CORRELATI
          </p>

          <div className="space-y-3 mb-8">
            <p className="text-zinc-500 text-[10px] font-mono uppercase mb-2">CHIANTIBANCA</p>
            {[
              { label: 'Bilancio 2025 — Comunicato ufficiale', url: 'https://www.chiantibanca.it/news/dettaglio_news_div.asp?i_menuID=72243&hNewsID=190809' },
              { label: 'La Nazione — Utile netto oltre 29M', url: 'https://www.lanazione.it/firenze/cronaca/chiantibanca-sorride-utile-netto-oltre-a1cfb08d' },
              { label: 'Gazzetta di Siena — Rafforza il territorio', url: 'https://www.gazzettadisiena.it/chiantibanca-rafforza-il-territorio-nel-2025-oltre-29-milioni-di-utile/' },
              { label: 'Sponsorizzazioni 2025 — 920k a 192 enti', url: 'https://www.chiantibanca.it/news/dettaglio_news.asp?i_menuID=72243&hNewsID=186575' },
            ].map((link, i) => (
              <a key={i} href={link.url} target="_blank" rel="noopener noreferrer"
                 className="flex items-center gap-3 p-3 border border-zinc-800 hover:border-[#00FF41]/30 transition-colors group">
                <span className="text-[#00FF41] font-mono text-xs flex-shrink-0">&#8250;</span>
                <span className="text-zinc-300 text-xs group-hover:text-white transition-colors">{link.label}</span>
              </a>
            ))}
          </div>

          <div className="space-y-3 mb-8">
            <p className="text-zinc-500 text-[10px] font-mono uppercase mb-2">FONDI PNRR & REGIONE TOSCANA</p>
            {[
              { label: 'Toscana Diffusa — Bandi rigenerazione urbana', url: 'https://www.regione.toscana.it/-/toscana-diffusa-contributi-per-interventi-di-riqualificazione-e-rigenerazione-urbana' },
              { label: 'PNRR Missione 5 — Inclusione e Coesione Toscana', url: 'https://pnrr.toscana.it/-/missione-5-inclusione-e-coesione' },
              { label: 'Regione Toscana — Fondi Europei 2021-2027', url: 'https://www.regione.toscana.it/fondi-europei-2021-2027' },
              { label: 'RESTART Prato — Riuso spazi commerciali sfitti', url: 'https://www.comune.prato.it/it/per-i-cittadini/partecipazione/percorsi-partecipativi/restart/pagina8401.html' },
              { label: 'Greenreport — 13,7M per 28 piccoli borghi', url: 'https://www.greenreport.it/news/territorio-e-smart-city/60106-toscana-diffusa-dalla-regione-13-7-mln-di-euro-per-rigenerare-28-piccoli-borghi' },
            ].map((link, i) => (
              <a key={i} href={link.url} target="_blank" rel="noopener noreferrer"
                 className="flex items-center gap-3 p-3 border border-zinc-800 hover:border-blue-400/30 transition-colors group">
                <span className="text-blue-400 font-mono text-xs flex-shrink-0">&#8250;</span>
                <span className="text-zinc-300 text-xs group-hover:text-white transition-colors">{link.label}</span>
              </a>
            ))}
          </div>

          <div className="space-y-3 mb-8">
            <p className="text-zinc-500 text-[10px] font-mono uppercase mb-2">NORMATIVA & FISCALITA</p>
            {[
              { label: 'Regime fiscale Imprese Sociali dal 2026 — Terzjus', url: 'https://terzjus.it/senza-categoria/dal-1-gennaio-2026-cambia-il-futuro-delle-imprese-sociali-un-nuovo-regime-fiscale-riconosce-il-loro-valore-sociale/' },
              { label: 'Cooperative sociali ETS — ENAC Online', url: 'https://enac-online.it/cooperative-sociali-ets/' },
              { label: 'Deducibilità sponsorizzazioni — KeySponsor', url: 'https://www.keysponsor.it/how-to/le-sponsorizzazioni-sono-completamente-deducibili/' },
              { label: 'Incentivi investitori Imprese Sociali — Fisco e Tasse', url: 'https://www.fiscoetasse.com/approfondimenti/13334-gli-incentivi-per-chi-investe-nelle-imprese-sociali.html' },
              { label: 'PNRR e Terzo Settore — Forum TS', url: 'https://pnrr.forumterzosettore.it' },
            ].map((link, i) => (
              <a key={i} href={link.url} target="_blank" rel="noopener noreferrer"
                 className="flex items-center gap-3 p-3 border border-zinc-800 hover:border-purple-400/30 transition-colors group">
                <span className="text-purple-400 font-mono text-xs flex-shrink-0">&#8250;</span>
                <span className="text-zinc-300 text-xs group-hover:text-white transition-colors">{link.label}</span>
              </a>
            ))}
          </div>
        </div>

        {/* ═══════════════════════════════════════════════════════ */}
        {/* LINK INTERNI PIATTAFORMA */}
        {/* ═══════════════════════════════════════════════════════ */}
        <div style={fadeIn(13)} className="mb-14">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-6">
            LINK INTERNI PIATTAFORMA
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {[
              { to: '/chiantibanca', label: 'Proposta ChiantiBanca (Pitch)', desc: 'Documento persuasivo completo' },
              { to: '/hub', label: 'Social Hub', desc: 'La piattaforma operativa' },
              { to: '/formazione', label: 'Formazione', desc: 'Corsi AI e competenze digitali' },
              { to: '/mentor', label: 'Mentor AI', desc: 'Sportello psicologico + AI chat' },
              { to: '/archivio', label: 'Archivio Digitale', desc: 'Gamification per scuole' },
              { to: '/generazioni', label: 'Generazioni', desc: 'Video reels formativi' },
              { to: '/dona', label: 'Sostieni il progetto', desc: 'Sistema donazioni' },
              { to: '/links', label: 'Roadmap Links', desc: 'Tutti i collegamenti' },
              { to: '/brand', label: 'Brand Identity', desc: 'Visual identity e logo' },
              { to: '/social', label: 'Piano Editoriale', desc: '54 post pronti (admin)' },
            ].map((item, i) => (
              <Link key={i} to={item.to}
                    className="flex items-center gap-3 p-3 border border-zinc-800 hover:border-[#00FF41]/30 transition-colors group">
                <span className="text-[#00FF41] font-mono text-xs font-bold flex-shrink-0">&#8250;</span>
                <div>
                  <p className="text-white text-xs font-bold group-hover:text-[#00FF41] transition-colors">{item.label}</p>
                  <p className="text-zinc-500 text-[10px]">{item.desc}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* Footer documento */}
        <div style={fadeIn(15)} className="text-center text-zinc-600 text-xs border-t border-zinc-900 pt-8 pb-4">
          <p className="text-zinc-500 font-mono text-[10px] mb-2">
            &lt;/AI_COVO.tech&gt;® — Strategia Finanziaria & Legale
          </p>
          <p>Documento generato il {new Date().toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
          <p className="text-zinc-700 mt-1">Colle Val d'Elsa — Toscana — Italia</p>
        </div>

      </div>
    </main>
  );
};

export default StrategiaPage;
